import { Button } from '@mui/material'
import React from 'react'
import { openModalFn } from '../../../../../../utils/controllers/ModalController'

const OnSiteRepairBtn = ({ currentServiceData, setOnSiteDrawerType }) => {
  const handleAction = () => {
    setOnSiteDrawerType && setOnSiteDrawerType('not-guarantee-repair')
    openModalFn['on-site-service-drawer']()
  }

  return (
    <Button
      onClick={handleAction}
      fullWidth
      variant='contained'
      disabled={!currentServiceData.equipmentId}
    >
      Выполнен негарантийный ремонт
    </Button>
  )
}

export default OnSiteRepairBtn
